import type { Root } from 'react-dom/client'

/** Evita unmount síncrono durante o render do React (race com createRoot). */
export function deferUnmountRoot(root: Root | null | undefined): void {
  if (!root) return
  queueMicrotask(() => {
    root.unmount()
  })
}
